import EventEmitter from 'methods/eventEmitter';
import {safeJSONParse, isPlainObject, firstUpper, formatMoney, createElement, declension} from 'methods/utils';

import Scroll from 'components/scroll';
import Search from 'components/search-v2';
import {ajaxGetData, ajaxSetData} from 'methods/ajaxData';

import BnovoApartmentPrices from './apartment-prices/bnovo';
import PrivetturApartmentPrices from './apartment-prices/privettur';
import SutochnoApartmentPrices from './apartment-prices/sutochno';
import OccupancyApartmentPrices from './apartment-prices/occupancy';
import TravellineApartmentPrices from './apartment-prices/travelline';
import PlansApartmentPrices from './apartment-prices/plans';
import metrikaCollector, {collectMailruReachGoal, collectYandexReachGoal} from 'components/metrika';

function ApartmentPrices(options = {}) {
    // наследуемся
    EventEmitter.call(this);

    this.$contactWrapper = document.querySelector('.js-contactWrapper');
    this.$calculator = this.$contactWrapper.querySelector('.js-calculateBlock');
    this.isInit = false;

    document.querySelectorAll('.js-checkPrice').forEach($el => $el.addEventListener('click', this._onCheckPriceClick.bind(this, $el)));

    // блок номеров, может не быть
    this.$apartmentBlock = document.querySelector('.js-roomsBlock');
    if (!this.$apartmentBlock) {
        this.$apartmentBlock = document.createElement('div');
    }

    if (!this.$calculator) {
        return console.error('Нету калькулятора');
    }

    this.$filterForm = this.$contactWrapper.querySelector('.js-filterForm');

    this.search = new Search(this.$filterForm, {
        datepickerPosition: 'right',
        datepickerHeader: true,
        peoplePosition: 'right',
        withPets: false,
        peopleSelected: true,
        enableErrorFields: true,
        calendarData: safeJSONParse(this.$filterForm.querySelector('.js-calendar-data').textContent, {}),
    });

    this.$findNumbersButtons = this.$contactWrapper.querySelectorAll('.js-find-apartments');
    this.$findNumbersButtons.forEach($el => $el.addEventListener('click', this.fakeRecalc.bind(this)));

    // получаем данные при загрузке страницы
    ajaxGetData().then((r) => {
        r.data.search = this.fillUrlDates(r.data.search);

        // прокидываем данные
        this.search.setData(r.data.search);

        // даты не заполнены
        if (this.search.getPeriodSearch() === 'Выберите даты') {
            this.search.showError({
                field: 'date',
                message: 'Выберите даты поездки',
            });
        }

        this.search.on('change', (data) => {
            this.recalc();
            this.emit('search:change', data);
        });
        this.search.on('submit', this.recalc.bind(this));

        this.recalc(false);
    });

    this.isInit = true;
}

// цепочка прототипов
ApartmentPrices.prototype = Object.create(EventEmitter.prototype, {
    constructor: {
        value: ApartmentPrices,
        enumerable: false,
        writable: true,
    }
});

ApartmentPrices.prototype.recalc = function(doScroll = true) {
    const formData = new FormData(this.$filterForm);

    // убираем ошибки
    this.search.hideError();

    // подрубаем прелоадер
    this.$apartmentBlock.classList.add('is-loading');

    this.updateCheckPriceVisibility();

    // даты не заполнены
    if (this.search.getPeriodSearch() === 'Выберите даты') {
        this.search.showError({
            field: 'date',
            message: 'Выберите даты поездки',
        });
    }

    // скроллим до апартаментов
    if (doScroll) {
        Scroll.to(document.getElementById('Apartment'), {
            offsetY: 173,
        }).catch(error => {});
    }

    // сохраняем данные поиска в сессию php
    ajaxSetData(formData);

    // запрос
    fetch('/hotels/ajax_calculate_apartments/', {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        // общая ошибка, отображается под блоком кол-ва детей
        if (r.status !== 'ok') {
            if (r.field) {
                return this.search.showError(r);
            } else {
                return this.search.showError('Ошибка рассчета стоимости');
            }
        }

        switch (r.calculate_type_id) {
            case 1: // по умолчанию для 1 воронки
                return (new PrivetturApartmentPrices(this, this.search)).render(r);
            case 2: // bnovo
                return (new BnovoApartmentPrices(this, this.search)).render(r);
            case 3: // суточно
                return (new SutochnoApartmentPrices(this, this.search)).render(r);
            case 4: // размещения
                return (new OccupancyApartmentPrices(this, this.search)).render(r);
            case 5: // тревеллайн
                return (new TravellineApartmentPrices(this, this.search)).render(r);
            default:
                return (new PlansApartmentPrices(this, this.search)).render(r);
        }
    })
    .finally(() => {
        this.$apartmentBlock.classList.remove('is-loading');
    });
}

ApartmentPrices.prototype.fakeRecalc = function(e) {
    this.$apartmentBlock.classList.add('is-loading');

    if (typeof yaCounter46243086 != 'undefined') {
        yaCounter46243086.reachGoal('find_hotel');
        collectYandexReachGoal(metrikaCollector, 'find_hotel');
    }

    setTimeout(() => {
        this.$apartmentBlock.classList.remove('is-loading');
    }, 1000);
}

ApartmentPrices.prototype.updateCheckPriceVisibility = function() {
    const searchData = this.search.getData();
    const hidden = !!(searchData.date_start && searchData.date_finish);

    document.querySelectorAll('.js-checkPrice')
        .forEach($el => $el.classList.toggle('is-hidden', hidden));
    document.querySelectorAll('.js-buttonChange')
        .forEach($el => $el.classList.toggle('is-hidden', !hidden));
    document.querySelectorAll('.js-find-apartments')
        .forEach($el => $el.classList.toggle('is-hidden', !hidden));
}

ApartmentPrices.prototype._onCheckPriceClick = function($el, e) {
    this.search.openDatePicker();

    if (typeof _tmr !== 'undefined') {
        _tmr.push({ type: 'reachGoal', id: 3512243, goal: 'check_prices'});
        collectMailruReachGoal(metrikaCollector, 'check_prices');
    }
}

ApartmentPrices.prototype.getSearchData = function() {
    return this.search.getData();
}

ApartmentPrices.prototype.setSearchData = function(data) {
    this.search.setData(data);
}

ApartmentPrices.prototype.fillUrlDates = function(data) {
    // даты заполнены
    if (data.date_start !== "" || data.date_finish !== "" || window.location.hash === "") {
        return data;
    }

    const parsedHash = new URLSearchParams(window.location.hash.substring(1));
    data.date_start  = parsedHash.get('date_start') ? parsedHash.get('date_start') : '';
    data.date_finish = parsedHash.get('date_finish') ? parsedHash.get('date_finish') : '';
    data.adults      = parsedHash.get('adults') ? parsedHash.get('adults') : 2;

    return data;
}

export default ApartmentPrices;
